import { useMemo, useState } from "react";
import { works, workTags } from "@/mocks/works";
import WorkCard from "@/components/feature/WorkCard";
import PageHeader from "@/components/feature/PageHeader";
import SectionHeading from "@/components/feature/SectionHeading";

const filterTabs = [
  { name: "全部", match: () => true },
  { name: "言情", match: (w: (typeof works)[number]) => w.tags.includes("言情") || w.tags.includes("甜宠") },
  { name: "奇幻热血", match: (w: (typeof works)[number]) => w.tags.includes("异世界") || w.tags.includes("战斗") || w.tags.includes("机甲") },
  { name: "穿书重生", match: (w: (typeof works)[number]) => w.tags.includes("穿书") || w.tags.includes("重生") || w.tags.includes("爽文") },
  { name: "校园青春", match: (w: (typeof works)[number]) => w.tags.includes("校园") || w.tags.includes("青春") },
  { name: "治愈美食", match: (w: (typeof works)[number]) => w.tags.includes("治愈") || w.tags.includes("美食") || w.tags.includes("日常") },
  { name: "已完结", match: (w: (typeof works)[number]) => w.status === "已完结" },
];

export default function TuijianPage() {
  const [tab, setTab] = useState(0);

  const list = useMemo(() => works.filter((w) => filterTabs[tab].match(w)), [tab]);

  return (
    <>
      <PageHeader
        title="新作与热门连载"
        subtitle="NEW &amp; HOT MANHWA · 在线看"
        desc="精选近期人气最高的韩国免费漫画新作与热门连载，题材覆盖言情、奇幻、热血、治愈等多个方向，日更无遮拦，点击即可在线看。"
        crumbs={[{ label: "新作推荐" }]}
      />

      <section className="mx-auto max-w-7xl px-4 md:px-6 py-8 md:py-12">
        <div className="flex flex-wrap gap-2">
          {filterTabs.map((t, i) => (
            <button
              key={t.name}
              type="button"
              onClick={() => setTab(i)}
              className={`px-3.5 py-1.5 rounded-full text-xs whitespace-nowrap transition-colors ${
                tab === i
                  ? "bg-primary-500 text-background-50 font-bold"
                  : "bg-background-100 text-foreground-700 hover:text-primary-500"
              }`}
            >
              {t.name}
            </button>
          ))}
        </div>

        <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {list.map((w) => (
            <WorkCard key={w.id} work={w} />
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 md:px-6 py-8 md:py-12">
        <SectionHeading
          eyebrow="HOT TAGS"
          title="大家都在搜这些题材"
          desc="看看时下最热门的韩漫题材关键词，帮你快速锁定想看的类型。"
        />
        <div className="flex flex-wrap gap-2.5">
          {workTags.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => {
                const target = filterTabs.findIndex((f, i) => {
                  if (i === 0) return false;
                  if (f.name === t) return true;
                  if (f.name.includes("言情") && (t.includes("甜") || t.includes("恋") || t.includes("冤家"))) return true;
                  if (f.name.includes("奇幻热血") && (t.includes("奇幻") || t.includes("科幻") || t.includes("冒险"))) return true;
                  if (f.name.includes("穿书重生") && (t.includes("穿书") || t.includes("重生") || t.includes("爽文"))) return true;
                  if (f.name.includes("校园青春") && t.includes("校园")) return true;
                  if (f.name.includes("治愈美食") && (t.includes("治愈") || t.includes("美食"))) return true;
                  return false;
                });
                setTab(target >= 0 ? target : 0);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="px-3 py-1.5 rounded-full bg-background-100 border border-background-300/50 text-xs text-foreground-700 hover:border-accent-500 hover:text-accent-500 transition-colors whitespace-nowrap"
            >
              # {t}
            </button>
          ))}
        </div>
      </section>
    </>
  );
}